import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CommonDatePicker from "../../../components/CommonDatePicker";
import StatusComp from "../../../components/StatusComp";
import toast from "react-hot-toast";
import moment from "moment/moment";
import { post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import CommonDatePickerReports from "../../../components/CommonDatePickerReports";
import ConsolidatedReport from "../../KnfSuperAdmin/Report/ConsolidatedReport";
import SelectBox from "../../../components/SelectBox";

const SiteAdminReport = () => {
  const location = useLocation();
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [cameraList, setCameraList] = useState([]);
  const [camTypes, setCamTypes] = useState([]);
  const [selecetdCam, setSelectedCam] = useState(null);
  const [reportData, setReportData] = useState({});

  const handlePreview = () => {
    if (!fromDate) {
      toast.error("Please Select From Date");
      return;
    }

    if (!toDate) {
      toast.error("Please Select To Date");
      return;
    }

    let formdata = new FormData();
    formdata.append("from_date", moment(fromDate).format("YYYY-MM-DD"));
    formdata.append("to_date", moment(toDate).format("YYYY-MM-DD"));
    formdata.append("site_id", user_details?.knf_company_site_id);

    if (selecetdCam?.value) {
      formdata.append("camera_id", selecetdCam?.value);
    }

    post(URL.GET_CONSOLIDATED_REPORT_ADMIN, formdata)
      .then((res) => {
        if (res?.data) {
          setReportData(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getCameraList = () => {
    let formdata = new FormData();
    formdata.append("site_id", user_details?.knf_company_site_id);
    post(URL.CAMERA_LISTS, formdata)
      .then((res) => {
        if (res?.cameras?.length > 0) {
          let temp = [];
          res?.cameras?.map((item, ind) => {
            let obj_ = {
              ...item,
              name_old: item?.name,
              name: `${item?.code} - ${item?.name}`,
            };
            temp.push(obj_);
          });
          setCameraList(temp);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCameraList();
  }, []);

  return (
    <div className="dashRightView">
      <StatusComp name={"Consolidated"} type={"Report"} />
      <div className={"d-flex gap-5"}>
        <CommonDatePickerReports
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={(even) => {
            setFromDate(even);
            setReportData({});
          }}
          setToDate={(even) => {
            setToDate(even);
            setReportData({});
          }}
        />

        <div className="col-md-2">
          <label className="form-label">Select Camera</label>
          <SelectBox
            arrayData={cameraList}
            data={camTypes}
            setData={setCamTypes}
            selectedOption={selecetdCam}
            setSelectedOption={(even) => {
              setSelectedCam(even);
              setReportData({});
            }}
            style={true}
          />
        </div>

        {/* Preview Button */}
        <div className="col-md- mt-4 d-flex flex-row flex-end">
          <button onClick={handlePreview} className="submit-btn">
            Preview
          </button>
        </div>
      </div>
      {reportData?.company && <ConsolidatedReport data={reportData} />}
    </div>
  );
};

export default SiteAdminReport;
